














import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator';

@Component({})
export default class SlipLineNoField extends Vue {
  private tooltip: string = '';
  @Prop()
  private value!: number | null;
  @Prop({default: 1})
  private min!: number;
  @Prop({default: null})
  private max!: number | null;
  @Prop({default: 1})
  private step!: number;
  @Prop({default: null})
  private appendClass!: string | JSON | null;
  @Prop({default: false})
  private disabled!: boolean;
  @Prop({default: true})
  private defaultStyle!: boolean;

  private alert: boolean = false;

  private style(): any {
    const style: any = {
      disabled: this.disabled,
      alert: this.alert,
      sliplinenofield: this.defaultStyle,
    };
    if (!this.appendClass) {
      return style;
    }
    if (typeof this.appendClass === 'string') {
      style[this.appendClass] = true;
      return style;
    }
    return Object.assign(style, this.appendClass);
  }

  @Emit('input')
  private update(event: Event): number | null {
    this.alert = false;
    const target = event.target as HTMLInputElement;

    if (!target.validationMessage) {
      if (this.hasValue(target.value)) {
        return Number(target.value);
      }
      return null;
    }

    this.alert = true;
    this.tooltip = target.validationMessage;
    this.$nextTick(() => {
      target.select();
    });
    if (this.hasValue(target.value)) {
      return Number(target.value);
    }
    return null;
  }

  @Emit('changed')
  private changed(event: Event): Event {
    return event;
  }

  private hasValue(value: string): boolean {
    if (!value) {
      return false;
    }
    if (value === '') {
      return false;
    }
    return true;
  }

  private isNumber(event: KeyboardEvent): boolean {
    const key = event.key;
    if (isNaN(Number(key))) {
      event.preventDefault();
      return false;
    }
    return true;
  }
 }
